import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* importProducts(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.PRODUCT_IMPORT.IMPORT_PRODUCTS, action.payload, true);
}
